<template>
	<div class="profilel" v-if="isPhone">
		<div class="top_box">
			<div class="logo_box" @click="showPop">
				<img class="logo_img" :src="img.lexus_logo">
				<div class="app_name">凌志范儿</div>
				<img class="down_arrow" :src="img.down_arrow">
			</div>
			<div class="download_block" @click="dowmloadApp">下载App</div>
		</div>
		<img class="bk_img" fit='contain' :src="img.bkimg">
		<div class="title">凌志范儿简介</div>
		<div class="content">1983年，丰田英二启动了“Team One”项目。6年后，凌志LS400（UCF10）诞生，并一举确立自己在豪华车市场的地位。今天，雷克萨斯代表的不单单是一个豪华车品牌，更是一种生活态度的象征，这里是凌志范儿……</div>
		<div class="bottom_text" v-if="years>0">
			<div>®2015-{{years}} 北京御城铭翼网络科技有限公司</div>
			<div>京ICP备15065994号-1 | 京ICP证B2-20181209号</div>
		</div>
		<div class="profile_mask" @click="hidePop" v-if="pop_box"></div>
		<div class="down_pop" v-if="pop_box">
			<div class="up_arrow"></div>
			<div class="down_pop_cell" @click="goFans('SubaruProfile')">
				<img class="down_pop_logo" :src="img.subaru_logo">
				<div class="down_pop_title">富士范儿</div>
			</div>
			<div class="down_pop_cell" @click="goFans('MotortimeProfile')">
				<img class="down_pop_logo" :src="img.motortime_logo">
				<div class="down_pop_title">汽车时间</div>
			</div>
			<div class="down_pop_cell" @click="hidePop">
				<img class="down_pop_logo" :src="img.lexus_logo">
				<div class="down_pop_title">凌志范儿</div>
			</div>
		</div>
	</div>
	<div v-else>
		<van-row type="flex" justify="center">
			<van-col span="8">
				<div class="profilel">
					<img class="bk_img" style="margin-top: 0px;" fit='contain' :src="img.bkimg">
					<div class="title" style="margin-top:45px;font-size: 30px;">凌志范儿简介</div>
					<div class="content" style="padding: 30px;font-size: 12px;">1983年，丰田英二启动了“Team One”项目。6年后，凌志LS400（UCF10）诞生，并一举确立自己在豪华车市场的地位。今天，雷克萨斯代表的不单单是一个豪华车品牌，更是一种生活态度的象征，这里是凌志范儿……</div>
					<div class="bottom_text" style="margin-top:22px;font-size: 10px;padding-bottom: 40px;" v-if="years>0">
						<div>®2015-{{years}} 北京御城铭翼网络科技有限公司</div>
						<div>京ICP备15065994号-1 | 京ICP证B2-20181209号</div>
					</div>
					
				</div>
			</van-col>
		</van-row>
	</div>
</template>
<script>
	import { mapState } from 'vuex';
	import { Grid, GridItem,Field,Button,Icon,Col, Row } from 'vant';
	export default {
		data () {
			return {
				img:{
					bkimg: require('../../assets/img/lexus/profile.png'),
					subaru_logo:require('../../assets/img/subaruf.png'),
					lexus_logo:require('../../assets/img/lexus.png'),
					motortime_logo:require('../../assets/img/motortimelogo.png'),
					down_arrow:require('../../assets/img/down_arrow.png'),
				},
				years:0,
				pop_box:false,
				isPhone:true
			}
		},
		computed: {
			...mapState({
				user: state => state.param.user,
				source: state => state.param.source
			})
		},
		created () {
			if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
				this.isPhone=true
			} else {
				this.isPhone=false
			}
			this.$store.commit('param/show', false)
			this.$appService.getToken(v => {
				if(v.token) {
					this.$store.dispatch('param/setToken', v.token)
				} else {
					this.$appService.needLogin()
				}
			})
			var newTime = new Date();
			this.years = newTime.getFullYear()

		},
		methods: {
			showPop(){
				this.pop_box=true
				document.body.style.overflow='hidden';
			},
			hidePop(){
				this.pop_box=false
				document.body.style.overflow='auto';
			},
			goFans(url){
				this.pop_box=false
				document.body.style.overflow='auto'
				this.$router.push({name:url});
				// let routeUrl = this.$router.resolve({name:url})
				//    window.open(routeUrl.href, '_blank')
			},
			dowmloadApp(){
				var u = navigator.userAgent, app = navigator.appVersion;
				var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; 
				var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
				if(isiOS){
					// window.open('https://apps.apple.com/cn/app/%E6%B1%BD%E8%BD%A6%E6%97%B6%E9%97%B4/id1084608468', '_blank')	
				}else{
					window.open('https://pic.motortime.com/app/LEXUS/lexus_pc.apk')
				}
			}
			
		},
		components: {
			[Grid.name]: Grid,
			[GridItem.name]: GridItem,
			[Field.name]:Field,
			[Button.name]:Button,
			[Col.name]:Col,
			[Row.name]:Row,
			[Icon.name]:Icon
		}
	}
</script>
<style lang="scss">
	
	.profilel{
		background-color: #000000;
		position:relative;
		.top_box{
			height: 55px;
			position:fixed;
			top: 0;
			left: 0;
			right: 0;
			background-color:#ffffff;
			display: flex;
			align-items:center;
			z-index: 1;
			.logo_box{
				display: flex;
				align-items:center;
				margin-left: 15px;
				flex: 1;
				.logo_img{
					width: 26px;
					height: 26px;
				}
				.app_name{
					font-size: 14px;
					font-weight: 600;
					margin-left: 10px;
				}
				.down_arrow{
					width: 12px;
					height: 7px;
					margin-left: 5px;
				}
				
			}
			.download_app{
				width: 50px;
				height: 18px;
				margin-right: 15px;
			}
			.download_block{
				color: #ffffff;
				font-size: 12px;
				padding:3px 10px;
				border-radius:30px;
				background-color:#000000;
				margin-right: 15px;
			}
			
		}

		.bk_img{
			margin-top: 55px;
			height: 100%;
			width: 100%;
		}
		.title{
			color: #FFFFFF;
			font-size: 30px;
			font-weight: bold;
			margin-top: 45px;
			text-align: center;
		}
		.content{
			color: #FFFFFF;
			font-size: 12px;
			padding: 20px;
			text-indent:2em;
			font-weight: 600;
			line-height: 1.6;
		}
		.bottom_text{
			color: #FFFFFF;
			font-size: 9px;
			text-align: center;
			margin-top: 70px;
			padding-bottom: 30px;
		}
		.down_pop{
			width: 120px;
			position:fixed;
			top: 60px;
			left: 15px;
			background-color:#ffffff;
			padding:0 15px 15px;
			z-index: 991;
		}
		.up_arrow{
			width: 0;
			height: 0;
			border-right:8px solid transparent;
			border-left:8px solid transparent;
			border-bottom:8px solid #FFFFFF;
			margin-top: -7px;
		}
		.down_pop_cell{
			display: flex;
			align-items:center;
			padding: 10px 0;
			border-bottom: 1px solid rgba(0, 0, 0, 0.6);
		}
		.down_pop_logo{
			width: 25px;
			height: 25px;
		}
		.down_pop_title{
			font-size: 14px;
			font-weight: 500;
			margin-left: 10px;
		}
		.profile_mask{
			position:fixed;
			top: 0;
			bottom:0;
			left: 0;
			right: 0;
			background-color:rgba(0, 0, 0, 0.5);
			z-index: 990;
		}
	}
</style>
